export default __webpack_public_path__ + "static/media/privacyPolicy.4396f310.pdf";